jQuery(document).ready(function() {
    if ((window.location.href.indexOf("case-studies/") > -1) || (jQuery('body').hasClass('single-post'))) {
        jQuery('.case-study-container .case-study-banner .banner-overlay').fadeIn(1500);
        // jQuery('.case-study-container .case-study-banner img').fadeIn(100);
    }
});